import { l } from '@manychat/manyui'

import * as atypes from 'apps/templates/constants/ReduxActionTypes'
import * as templateStoreActions from 'apps/templateStore/actions/templateStoreActions'
import { alert } from 'common/core'
import { addNotification } from 'common/core/actions/uiActions'
import * as API from 'constants/API'
import { analyticsService } from 'utils/services/analytics'
import errorTrackingService from 'utils/services/errorTrackingService'

export const resolveConflict = (data) => ({ type: atypes.RESOLVE_CONFLICT, data })
export const setSettings = (data) => ({ type: atypes.SET_SETTINGS, data })

const isStoreId = (id) => !isNaN(id)

export const fetchBotTemplate = (templateHash) => {
  if (isStoreId(templateHash)) {
    return templateStoreActions.fetchTemplate(templateHash)
  }
  return {
    type: atypes.BOT_TEMPLATE_FETCH,
    $fetch: API.botTemplate.endpoints.fetch.replace(':template_hash', templateHash),
    $error: () => {},
  }
}

export const fetchTemplateGeneralElement = (templateId, element) => {
  const isStoreTemplate = isStoreId(templateId)
  const endpoints = API[isStoreTemplate ? 'storeTemplates' : 'botTemplate'].endpoints
  const elementsMap = {
    wm: endpoints.fetchWelcomeMessage,
    mm: endpoints.fetchMainMenu,
    dr: endpoints.fetchDefaultReply,
  }

  return {
    type: atypes.BOT_TEMPLATE_GENERAL_ELEMENT_FETCH,
    $fetch: elementsMap[element].replace(isStoreTemplate ? ':id' : ':template_hash', templateId),
    element,
  }
}

export const installBotTemplate =
  (id, pageId, signature, options = {}) =>
  async (dispatch, getState) => {
    const state = getState()
    const customEventsMap = state.targetPage.customEventsMap
    const tagsMap = state.targetPage.tagsMap
    const cufsMap = state.targetPage.cufsMap
    const gafsMap = state.targetPage.gafsMap
    const otnsMap = state.targetPage.otnsMap
    const conflicts = state.templates.installation.generalElementsConflicts
    const settings = state.templates.installation.settings
    const isStoreTemplate = isStoreId(id)
    const endpoints = API[isStoreTemplate ? 'storeTemplates' : 'botTemplate'].endpoints

    try {
      const response = await dispatch({
        type: atypes.BOT_TEMPLATE_INSTALL,
        signature: signature,
        $fetch: [
          endpoints.install.replace(isStoreTemplate ? ':template_id' : ':template_hash', id),
          {
            method: 'POST',
            body: JSON.stringify({
              page_id: pageId.replace('fb', ''),
              replace_welcome_message: conflicts.wm,
              replace_default_reply: conflicts.dr,
              replace_main_menu: conflicts.mm,
              replace_greeting_text: conflicts.gtext,
              replace_ig_default_reply: conflicts.igdr,
              replace_story_mention_reply: conflicts.sm,
              replace_ice_breakers: conflicts.ib,
              replace_ig_ice_breakers: conflicts.igib,
              replace_ig_main_menu: conflicts.igmm,
              mapping_settings: {
                custom_fields: cufsMap,
                tags: tagsMap,
                global_fields: gafsMap,
                otn_reasons: otnsMap,
                custom_events: customEventsMap,
              },
              fill_fields: settings,
              async: signature,
              ...options,
            }),
            headers: { 'Content-Type': 'application/json' },
          },
        ],
        $error: () => {},
        $success: () => {
          if (isStoreTemplate) {
            analyticsService.sendEvent('TEMPLATE_STORE.INSTALL_TEMPLATE', {
              template_id: id,
            })
          }
        },
      })

      return response
    } catch (error) {
      const { response } = error

      if (!response) {
        alert(l.translate('Something went wrong on the server. Please try again.'), 'danger')
        errorTrackingService.logError(error, {
          scope: 'root',
          section: null,
          fingerprint: 'templateInstallation.installBotTemplate',
        })
        return
      }

      dispatch(addNotification(response, 'danger'))
    }
  }

export const resetInstallation = () => ({
  type: atypes.TEMPLATES_INSTALLATION_RESET,
})
